import { sha256 as nobleSha256 } from "@noble/hashes/sha2.js";
import { PkilError } from "./errors.js";

export const HASH_SIZE = 32;

/** Synchronous SHA-256 (@noble/hashes); identical in browser, worker and Node. */
export function sha256(b: Uint8Array): Uint8Array {
  return nobleSha256(b);
}

/** chunk_hash = SHA-256(previous_chunk_hash ‖ chunk_bytes), over the uncompressed chunk bytes (arch §9.2). */
export function chunkHash(prevHash: Uint8Array, bytes: Uint8Array): Uint8Array {
  if (prevHash.length !== HASH_SIZE) throw new PkilError("ARGUMENT", `prevHash must be ${HASH_SIZE} bytes, got ${prevHash.length}`);
  const h = nobleSha256.create();
  h.update(prevHash);
  h.update(bytes);
  return h.digest();
}
